import ErrorUtils from '~/utils/error_utils';
import { objectToFormData } from '~/utils/utils';

export default {
    searchSavedMedia(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/search-saved',
                method: 'GET',
                data: params,
                global: false
            })
            .done(data => {
                resolve(data);
            })
            .fail(xhr => {
                reject(xhr);
            })
        })
    },

    getPreviewData(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/preview',
                method: 'POST',
                data: params,
                global: false
            })
            .done(data => {
                resolve(data);
            })
            .fail(xhr => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            })
        })
    },

    updatePreviewAssets(params) {
        params = objectToFormData(params);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/update-preview-assets',
                method: 'POST',
                data: params,
                global: false,
                contentType: false,
                processData: false,
            })
            .done(data => {
                resolve(data);
            })
            .fail(xhr => {
                console.error(xhr);
                reject(xhr);
            })
        })
    },

    getMediaAssets(id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/assets/' + id,
                method: 'GET',
                global: false
            })
            .done(data => {
                resolve(data);
            })
            .fail(xhr => {
                reject(xhr);
            })
        })
    },

    getGalleryNavigation(item) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/media/gallery-nav-json`,
                method: 'GET',
                data: item,
                global: false
            })
            .done(data => {
                resolve(data);
            })
            .fail(xhr => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            })
        })
    },

    getPrebuiltScenarios(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/prebuilt-scenarios-dt',
                method: 'GET',
                data: params,
                global: false
            })
                .done(data => {
                    resolve(data);
                })
                .fail(xhr => {
                    reject(xhr);
                })
        })
    }
}